<div *ngIf="displayOpenBuilder" class="edit-website" fxLayout="row" fxLayoutGap="10">
    <div fxFlex="50%">
        This bar is only visible to you.
    </div>
    <div fxFlex="50%">
        <span (click)="openBuilder()">Edit your website</span> |
        <span (click)="openSetting()" class="mr-2">Settings</span> |
        <span (click)="logout()" class="ml-2">Logout</span>
    </div>
</div>

<div *ngIf="active && (siteMenu$ | async) as siteMenu" id="header-container"
    [ngClass]="siteMenu.length>0 && transparentHeader && isHomePage ?'absolute-header-container':''">
    <mat-toolbar color="primary" class="mat-elevation-z6 header"
        [ngClass]="siteMenu.length>0 && transparentHeader && isHomePage  ?'no-shadow':''"
        [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor && backgroundColor.includes('#')?'none':backgroundColor }">
        <mat-toolbar-row class="mat-elevation-z10"
            [ngClass]="siteMenu.length>0 && transparentHeader && isHomePage  ?'no-shadow':''">
            <button *ngIf="siteMenu.length>0"
                [ngStyle]="{ 'color': backgroundColor == '#fff' || backgroundColor == '#ffffff' ? '#cecece' : '' }"
                mat-icon-button fxShow="true" fxHide.gt-sm (click)="toggleRightSidenav()" aria-label="menu">
                <mat-icon>menu</mat-icon>
            </button>
            <div class="logo-container">
                <div *ngIf="companyLogo" class="display-logo">
                    <span *ngIf="companyLogo.choice === 'text'" class="logo-text"
                        (click)="redirectFromHeader(companyLogo.link)" [ngStyle]="{ 'color': textColor }">{{
                        companyLogo.text }}</span>
                    <span *ngIf=" companyLogo.choice === 'image'" class="logo-text"
                        (click)="redirectFromHeader(companyLogo.link)"><img [alt]="siteName"
                            src="{{ companyLogo.logo }}" class="logo-image"></span>
                </div>
            </div>

            <!-- max logo Height : 32 px -->
            <!-- <ng-template #showCompanyLogo> <img class="companyLogo" [src]="companyLogo | safe:'url'"> </ng-template> -->
            <span class="fill-remaining-space"></span>
            <nav>
                <div fxShow="true" fxHide.lt-md>
                    <!-- The following menu items will be hidden on both SM and XS screen sizes -->
                    <span *ngFor="let item of siteMenu" [ngStyle]="{ 'color': textColor }"
                        [ngClass]="item.type=='button'?'button-header':''">
                        <a (click)="navigateTo(item.link)" *ngIf="item.title == 'ecom'" [routerLink]="['/cart']"
                            mat-button [ngStyle]="{ 'color':'#fff' }">
                            <mat-icon class="toolbar-icon ecom-icon" aria-hidden="false">shopping_cart</mat-icon>
                        </a>
                        <a (click)="navigateTo(item.link)" *ngIf="!item.option && item.title != 'ecom'"
                            [routerLink]="['/']" [fragment]="item.newUrl" mat-button> {{ item.title }}</a>
                        <a (click)="navigateTo(item.link)"
                            *ngIf="item.option && item.link.length<5 && item.title != 'ecom'" [routerLink]="['/']"
                            [fragment]="item.newUrl" mat-button> {{ item.title }}</a>
                        <a *ngIf="item.option && item.link.length>5 && item.title != 'ecom'" rel="noopener"
                            [target]="item.option" [href]="item.link | safeUrl" mat-button
                            [ngStyle]="{ 'color': item.type=='button'?'#fff':textColor }"> {{ item.title }}</a>
                    </span>

                    <!-- 
                    <mat-icon class="toolbar-icon" aria-hidden="false" aria-label="Example heart icon">favorite</mat-icon>
                    -->
                </div>
            </nav>
            <a *ngIf="ecommerceExist" class="panier-mobile" (click)="navigateTo(item.link)" [routerLink]="['/cart']"
                mat-button [ngStyle]="{ 'color':'#fff' }">
                <mat-icon class="toolbar-icon ecom-icon" aria-hidden="false">shopping_cart</mat-icon>
            </a>
        </mat-toolbar-row>
    </mat-toolbar>
</div>